export function isNonEmpty(value?: string | null) {
    return typeof value === 'string' && value.trim().length > 0;
}
